import convert from 'convert-units';

/**
 * Splits a patient height stored as decimal feet into whole feet and inches for the height inputs. Truncates the value to whole feet and converts the fractional remainder from feet to inches, rounding it, returning an empty object when the whole-feet part is zero or missing.
 *
 * @param decimalHeight - Height in decimal feet.
 * @returns Object with ft and rounded ins, or an empty object when there are no whole feet.
 */
const convertDecimalHeightToFeetInch = (decimalHeight: any) => {
  const newFt = parseInt(decimalHeight, 10);
  const newIns = convert(decimalHeight - newFt)
    .from('ft')
    .to('in');
  if (newFt) {
    return {
      ft: newFt,
      ins: Math.round(newIns),
    };
  }
  return {};
};

/**
 * Combines the feet and inches height inputs back into the decimal feet value stored on a patient. Converts the inches part to feet and adds it to the numeric feet part.
 *
 * @param feet - Whole feet part of the height.
 * @param inch - Inches part of the height.
 * @returns Height expressed in decimal feet.
 */
const convertFeetInchToDecimalHeight = (feet: any, inch: any) => {
  const addFeet = convert(inch).from('in').to('ft');
  return parseFloat(Number(feet) + addFeet);
};

export { convertDecimalHeightToFeetInch, convertFeetInchToDecimalHeight };
